import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError, EMPTY, of } from 'rxjs';
import { login } from '../model/login';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { AppSetting } from '../model/setting/SystemControl';
import { response } from '../model/Response';
import { LocalStorageService } from './LocalStorageService';
import { DashboardModel } from '../model/DashboardModel';
import { AppState } from '../store/buid.reducer';
import { select, Store } from '@ngrx/store';
export interface DateRangeState {
  startDate: string;
  endDate: string;
  filter: string;
}
@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  myAppApi: string;
  myAppUrlLogin: string;
  private userSubject: BehaviorSubject<login>;
  public loginSubject: Observable<login>;

  BUID: string;
  constructor(
    private _http: HttpClient,
    private router: Router,
    private storageService: LocalStorageService,
    private store: Store<AppState>

  ) {
    this.myAppApi = environment.appUrl;
    this.myAppUrlLogin = 'api/Authentication';
    this.store.pipe(select(state => state.buidState.BUID)).subscribe(buid => {
      this.BUID = buid
    });

  }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      Accept: '*/*',
    }),
  };





  //App Setting
  apiResponse: any;
  getAppSetting(source: string): Observable<AppSetting> {
    return this._http
      .get<response>(
        this.myAppApi + 'api/Master/BusinessSettingList?Id=0',
        this.httpOptions
      )
      .pipe(
        map((response) => {
          this.apiResponse = response;
          return this.apiResponse.data[0];
        })
      );
  }
  // for dashboard 
  private dateRangeSubject = new BehaviorSubject<DateRangeState>({
    filter: localStorage.getItem('DATE_RANGE_TYPE') ?? 'TODAY',
    startDate: localStorage.getItem('SD') ?? '',
    endDate: localStorage.getItem('ED') ?? '',
  });
  dateRange$ = this.dateRangeSubject.asObservable();

  emitDateRange(filter: string, startDate: string, endDate: string) {
    this.dateRangeSubject.next({ filter, startDate, endDate });
  }

  //   getTopHeader(source: string,startDate?,endDate?): Observable<DashboardModel> {
  //     //  Format to yyyy-MM-dd
  // const formatDate = (dateStr: string): string => {
  //   if (!dateStr) return '';
  //   const d = new Date(dateStr);
  //   const yyyy = d.getFullYear();
  //   const mm = String(d.getMonth() + 1).padStart(2, '0');  
  //   const dd = String(d.getDate()).padStart(2, '0');       
  //   return `${yyyy}-${mm}-${dd}`;
  // };

  //   const formattedStart = formatDate(startDate);
  //   const formattedEnd = formatDate(endDate);
  //   let api =
  //       `api/Dashboard/MainDashboard?Event=1&Id=0&VoucherNo=&MonthName=&DayType=&Location=&BranchId=&LicId=&Source=&Station=&LedgerCode=&UserName=&StartDate=${formattedStart}&EndDate=${formattedEnd}&CurrentPage=1&PageSize=100`;
  //     return this._http.get<response>(this.myAppApi + api, this.httpOptions).pipe(
  //       map((response) => {
  //         // this.apiResponse = response;
  //         // return this.apiResponse.data[0];
  //         this.apiResponse = response;
  //       return this.apiResponse.data;
  //       })
  //     );
  //   }

  getTopHeader(source: string, startDate?: string, endDate?: string): Observable<DashboardModel[]> {
    const formatDate = (dateStr: string): string => {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };

    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    let api = `api/Dashboard/MainDashboard?Event=1&Id=0&VoucherNo=&MonthName=&DayType=&Location=&BranchId=${this.BUID}&LicId=&Source=&Station=&LedgerCode=&UserName=&StartDate=${formattedStart}&EndDate=${formattedEnd}&CurrentPage=1&PageSize=100`;

    return this._http.get<response>(this.myAppApi + api, this.httpOptions).pipe(
      map((response) => {
        this.apiResponse = response;
        return this.apiResponse.data as DashboardModel[]; //  cast to array
      })
    );
  }
  getCashBankLedgerForDashboard(source: string, startDate?: string, endDate?: string): Observable<DashboardModel[]> {
    const formatDate = (dateStr: string): string => {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };

    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    let api = `api/Dashboard/CashBankDetails?Event=5&Id=0&VoucherNo=&MonthName=&DayType=&Location=&BranchId=${this.BUID}&LicId=&Source=&Station=&LedgerCode=&UserName=&StartDate=${formattedStart}&EndDate=${formattedEnd}&CurrentPage=1&PageSize=100`;

    return this._http.get<response>(this.myAppApi + api, this.httpOptions).pipe(
      map((response) => {
        this.apiResponse = response;
        return this.apiResponse.data as DashboardModel[]; //  cast to array
      })
    );
  }

  searchInfoList(searchParam: string, branchId: string = '0'): Observable<any[]> {
    const api = `api/Master/SearchInfoList?Event=1&SearchType=ledgerinfo&BranchId=${branchId}&SearchParam=${encodeURIComponent(searchParam)}&OffSet=1&PageSize=20`;
    return this._http.get<response>(this.myAppApi + api, this.httpOptions).pipe(
      map((response: any) => {
        return (response?.data || []).filter((item: any) => item.url || item.ledgerName || item.name);
      })
    );
  }


  //.............................................end of company area......................................//
  errorHandler(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
